import React from "react";
import PropTypes from "prop-types";
import Button from "../Button";
import Lightbox from "../Lightbox";
import Review from "./Review";

import styles from "./reviews.module.scss";

class ProductReviews extends React.Component {
  state = {
    modalIsOpen: false,
    currentIndex: 0
  };
  closeModal = (event) => {
    if (window.$(event.target).closest(`.lightbox-view`).length) {
      return;
    }
    this.setState({
      modalIsOpen: false,
      currentIndex: 0
    });
  };
  openModal = (index) => (event) => {
    event.preventDefault();
    this.setState({
      modalIsOpen: true,
      currentIndex: index
    });
  };
  createMarkup(html) {
    return {__html: html};
  }
  render() {
    const {modalIsOpen, currentIndex} = this.state;
    const {
      title,
      reviews: {path, content},
      withoutTitle
    } = this.props;
    return content.length ? (
      <div className={styles.root}>
        {!withoutTitle && <h2 className={styles.title}>{title}</h2>}
        <div className={styles.reviews}>
          {content.map((review, index) => (
            <Review
              key={review.id}
              content={review}
              onClick={this.openModal(index)}
            />
          ))}
        </div>
        <Lightbox
          items={content.map(({photo: source, ...captionContent}) => ({
            source,
            captionContent
          }))} // need create content {source, и т.д.}
          isOpen={modalIsOpen}
          currentIndex={currentIndex}
          captionRender={({
            captionContent: {author, date, comments, orderedProducts}
          }) => (
            <div>
              <div className={styles.reviewHeader}>
                <span className={styles.author}>{author}</span>
                <span className={styles.date}>{date}</span>
                <div className={styles.order}>
                  <span>В заказе: </span>
                  <span
                    dangerouslySetInnerHTML={this.createMarkup(orderedProducts)}
                  />
                </div>
              </div>
              <div className={styles.reivewComments}>{comments}</div>
            </div>
          )}
          onClose={this.closeModal}
        />
        <div className={styles.footer}>
          <Button href={path} variant="contained" style="secondary">
            Перейти ко всем отзывам
          </Button>
        </div>
      </div>
    ) : null;
  }
}

ProductReviews.propTypes = {
  title: PropTypes.string,
  reviews: PropTypes.shape({
    counts: PropTypes.number,
    path: PropTypes.string,
    content: PropTypes.array
  }),
  withoutTitle: PropTypes.bool
};

export default ProductReviews;
